/* @jsx h */
import { defineComponent, h, onMounted } from "vue";
import { setTitle } from "@lemmonhq/orders";
import { useLocalization } from "@lemmonhq/uikit";

// Group-mode Data Room. Header mirrors the Reports Data Room; the body is a
// placeholder until consolidated group reporting datasets land here.
export const GroupDataRoomPage = defineComponent({
  name: "GroupDataRoomPage",
  setup() {
    const { t } = useLocalization();

    onMounted(() => setTitle(t("admin.dataroom.title")));

    return () => (
      <div class="flex h-full flex-1 flex-col overflow-hidden bg-base-200/40">
        {/* Header */}
        <div class="border-b border-base-300/50 bg-base-200/60 px-4 pt-4 pb-4 backdrop-blur-sm sm:px-6">
          <div class="flex items-center gap-2.5">
            <span class="grid h-9 w-9 place-items-center rounded-xl bg-primary/10 text-primary">
              <span class="material-symbols-outlined text-xl">database</span>
            </span>
            <div>
              <h1 class="text-lg font-semibold leading-tight text-accent">
                {t("admin.dataroom.title")}
              </h1>
              <p class="text-xs leading-tight text-base-content/55">
                {t("admin.dataroom.subtitle")}
              </p>
            </div>
          </div>
        </div>

        {/* Body */}
        <div class="min-h-0 flex-1 overflow-y-auto px-4 sm:px-6">
          <div class="mx-auto flex h-full w-full max-w-[1400px] items-center justify-center py-16">
            <div class="flex flex-col items-center gap-3 rounded-2xl border border-base-300 bg-base-100 px-10 py-14 text-center shadow-sm">
              <span class="grid h-14 w-14 place-items-center rounded-2xl bg-primary/10 text-primary">
                <span class="material-symbols-outlined text-3xl">database</span>
              </span>
              <h2 class="text-lg font-semibold text-accent">
                {t("admin.dataroom.title")}
              </h2>
              <p class="max-w-sm text-sm text-base-content/60">
                {t("admin.dataroom.coming_soon")}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
